import { coreFeatures, createTableHook, tableFeatures } from '@tanstack/react-table';

export const {
  useAppTable,
  createAppColumnHelper,
  useTableContext,
  useCellContext,
  useHeaderContext,
} = createTableHook({
  features: tableFeatures(coreFeatures),
});
